export default __webpack_public_path__ + "static/media/1193.5dc58118.png";